import BasicHeader from '../../BasicHeader';

class PreviewHeader extends BasicHeader {
  protected override anchorIdEnabled = true;
}

export default PreviewHeader;
